module.exports = __webpack_public_path__ + "qr_code_android_civic.53e09cb.png";